import { ReactElement } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { EAppRoutes } from '@common/enums';

/**
 * Guard to validate if creativeId search param available in route path.
 * Redirects to home page if empty.
 */
export const CreativeIdParamGuard = (): ReactElement => {
  const params = useParams();
  const location = useLocation();

  if (!params.creativeId) {
    return <Navigate to={{ pathname: EAppRoutes.Home, search: location.search }} />;
  }

  return <Outlet />;
};
